export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'radial-gradient(circle at 25% 25%, oklch(var(--primary-500)) 1px, transparent 1px), radial-gradient(circle at 75% 75%, oklch(var(--accent-500)) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        ></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs text-primary-400 font-medium whitespace-nowrap">
                实时追踪 · 深度爆料 · 每日更新
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              暗网吃瓜
              <span className="block text-primary-400 mt-1">
                全网黑料检索与爆料聚合平台
              </span>
            </h1>

            <p className="text-lg text-accent-400 font-heading mb-6">
              不生产瓜，只做最硬核的吃瓜搬运工
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                暗网吃瓜致力于打造全网最全面的黑料查询与爆料聚合平台。覆盖娱乐圈、网红圈、科技圈、商业圈等多个领域，
                通过智能检索系统帮助用户快速定位最新爆料与历史黑料档案。所有内容由社区匿名投稿与公开信息聚合而成，
                本站不对内容真实性负责，仅供吃瓜参考。当前平台已收录超过
                <strong className="text-primary-400"> 3000+ </strong>
                条爆料记录，日均更新
                <strong className="text-primary-400"> 50+ </strong>
                条新鲜热瓜。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400 font-heading">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">爆料收录</div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400 font-heading">50+</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新</div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400 font-heading">200+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖频道</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-flashlight-line mr-2"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3 border border-background-300/50 hover:border-primary-500/50 text-foreground-700 hover:text-primary-400 rounded-lg transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-mail-send-line mr-2"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:w-auto flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20digital%20abstract%20composition%20with%20glowing%20warm%20amber%20and%20deep%20red%20accents%20against%20charcoal%20black%20background%2C%20data%20visualization%20elements%2C%20encrypted%20text%20fragments%2C%20minimalist%20cyberpunk%20aesthetic%2C%20editorial%20quality%2C%20deep%20shadows%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20dark%20ambient%20style&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="暗网吃瓜 - 黑料检索与爆料聚合平台"
                className="w-full h-full object-cover rounded-2xl border border-background-300/30"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent pointer-events-none"></div>
    </section>
  );
}